const common = {
  actions: {
    cancel: 'Annuler',
    close: 'Fermer',
    delete: 'Supprimer',
    edit: 'Modifier',
    refresh: 'Actualiser',
    retry: 'Réessayer',
    save: 'Enregistrer',
  },
  dialog: {
    close: 'Fermer la boîte de dialogue',
  },
  documentTitle: 'SpeedGauge Coach AI | Sécurité des flottes',
  dropdown: {
    clearSearch: 'Effacer la recherche',
    clearSearchText: 'Effacer le texte de recherche',
    noMatchingOptions: 'Aucune option correspondante',
    searchLabel: 'Rechercher {{label}}',
    searchPlaceholder: 'Rechercher...',
  },
    header: {
      accountAndSettings: 'Compte et paramètres',
      accountMenu: 'Menu du compte',
      adminDashboard: 'Tableau de bord administrateur',
      allVehicles: 'Tous les véhicules',
      backToChat: 'Retour au chat',
      closeSidebar: 'Fermer la barre latérale du chat',
      customer: 'Client :',
      loadingFleetList: 'Chargement de la liste des flottes',
      loggingOut: 'Déconnexion...',
      newSession: 'Nouvelle session',
      openSidebar: 'Ouvrir la barre latérale du chat',
      returnToSafetyCenter: 'Retourner à Safety Center',
      selectCustomer: 'Sélectionner un client',
      selectVehicleGroup: 'Sélectionner un groupe de véhicules',
      vehicleGroup: 'Groupe de véhicules :',
    },
    sidebar: {
      ariaLabel: 'Barre latérale du chat',
      collapse: 'Réduire la barre latérale',
      coachSuggestions: 'Suggestions du Coach',
      guidedTours: 'Visites guidées',
      help: 'Aide',
      history: 'Historique',
      newSession: 'Nouvelle session',
      newSessionTitle: 'Nouvelle session (nouveau chat)',
      recentChats: 'Chats récents',
      savedPrompts: 'Prompts enregistrés',
      settings: 'Paramètres',
    },
  status: {
    loading: 'Chargement...',
    noResults: 'Aucun résultat trouvé.',
    saving: 'Enregistrement...',
  },
} as const;

export default common;